import type { NatsConnection } from 'nats.ws';
import type { Nats } from '../types.js';
import { proxy } from './nats.js';

export type { Props } from './types.js';

/** NATS public interface. */
export const nats: Nats & { isLocal: boolean; isLocalModeCapable: boolean } = {
  agentConnection(agentId: string): NatsConnection {
    return proxy.newtsConnectionForAgentId(agentId);
  },

  cloudConnection(): NatsConnection {
    return proxy.natsConnection;
  },

  get isConnected(): boolean {
    return proxy.isConnected;
  },

  off(...args): void {
    proxy.off(...args);
  },

  on(...args): ReturnType<Nats['on']> {
    return proxy.on(...args);
  },

  async forceUnauthenticatedConnect(): Promise<void> {
    //return proxy.connectNats(undefined);
  },

  get isLocal(): boolean {
    return proxy.isLocal;
  },

  get isLocalModeCapable(): boolean {
    return proxy.localModeCapable;
  },

  async watchForDeviceIDOnLocal(_deviceId: string): Promise<void> {
    console.error('watchForDeviceIDOnLocal not implemented');
  }
};

export { Provider } from './provider.jsx';
